import { CheckboxProps } from "@/src/common/types"
import React from "react"

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  checked,
  onChange,
  label,
  name
}) => (
  <div className="flex items-center cursor-pointer">
    <label htmlFor={id} className="flex items-center">
      <div className="relative w-4 h-4 border-[0.5px] shrink-0 dark:border-[#4B5563] bg-gray-200 dark:bg-[#1A1D21] cursor-pointer">
        <input
          type="checkbox"
          id={id}
          name={name}
          checked={checked}
          onChange={onChange}
          className="hidden peer"
        />
        <div className="hidden top-0 left-0 absolute w-full h-full peer-checked:flex justify-center items-center border-[0.5px] dark:border-white bg-gray-200 dark:bg-[#1A1D21] dark:text-white">
          <span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.6515 5.1415C11.8495 4.94901 12.166 4.95347 12.3585 5.15146C12.551 5.34945 12.5465 5.666 12.3485 5.8585L7.20568 10.8585C7.01162 11.0472 6.70266 11.0472 6.5086 10.8585L3.65146 8.08072C3.45347 7.88823 3.44901 7.57168 3.6415 7.37368C3.834 7.17569 4.15055 7.17123 4.34854 7.36373L6.85714 9.80265L11.6515 5.1415Z"
                fill="currentColor"
              />
            </svg>
          </span>
        </div>
      </div>
      <span
        className={`text-xs font-normal cursor-pointer capitalize text-gray-700 text-balance ${
          checked ? "text-white" : "dark:text-[#9CA3AF]"
        }
      ml-2 cursor-default`}
      >
        {label}
      </span>
    </label>
  </div>
)

export default Checkbox
